import * as React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import { axisClasses } from '@mui/x-charts/ChartsAxis';

const chartSetting = {
  yAxis: [
    {
      label: 'Performance (%)',
      colorMap: undefined
    },
  ],
  height: 220,
  sx: {
    [`.${axisClasses.left} .${axisClasses.label}`]: {
      transform: 'translate(-7px, 0)',
    },
    pl: 1.5,
    '& .MuiChartsLegend-root text': { fontSize: '.875rem !important', },
  },
  slotProps: {
    legend: {
      direction: 'row',
      position: { vertical: 'bottom', horizontal: 'middle' },
      padding: -15,
    },
  },
};

const PerformanceBar = ({ data, sp500vsPerf }) => {
  if (data === undefined || data === null) {
    return <div></div>;
  }
  let dataArray;
  let sp500vsPerfArray;
  try {
    dataArray = JSON.parse(data);
    sp500vsPerfArray = sp500vsPerf && sp500vsPerf !== "" ? JSON.parse(sp500vsPerf) : [];
  } catch (error) {
    console.error('Error parsing data:', error);
    return <div></div>;
  }

  if (!Array.isArray(dataArray) || dataArray.length === 0) {
    return <div></div>;
  }

  const mergedData = dataArray.map(item => {
    const sp500Item = sp500vsPerfArray.find(sp500 => sp500.year === item.year.toString());
    return {
      year: item.year,
      perf: item.perf,
      sp500: sp500Item ? sp500Item.pch : 0
    };
  });

  return (
    <>
      <BarChart
        skipAnimation={true}
        dataset={sp500vsPerf ? mergedData : dataArray}
        grid={{ horizontal: true }}
        xAxis={[
          {
            scaleType: 'band',
            dataKey: 'year',
            valueFormatter: (value) => value.toString(),
          },
        ]}
        series={sp500vsPerf ?
          [
            { dataKey: 'perf', label: 'Performance', valueFormatter: (value) => `${value}%`, color: '#174c86' },
            { dataKey: 'sp500', label: 'S&P 500', valueFormatter: (value) => `${value}%`, color: 'rgb(90, 133, 194)' },
          ] :
          [{ dataKey: 'perf', label: 'Performance', valueFormatter: (value) => `${value}%`, color: '#174c86' }]}
        {...chartSetting}
      />
    </>
  );
}
export default PerformanceBar;
